import type { IssueDependencyType, IssueLinkType } from '@pulse/shared';

export const DEPENDENCY_TYPES: IssueDependencyType[] = ['FF', 'FS', 'SF', 'SS'];

export const DEPENDENCY_TYPE_LABELS: Record<IssueDependencyType, string> = {
  FF: 'Finish-to-Finish (FF)',
  FS: 'Finish-to-Start (FS)',
  SF: 'Start-to-Finish (SF)',
  SS: 'Start-to-Start (SS)',
};

/** Display label for a link row — appends the dependency type for a 'Depends on' link (e.g.
 *  "Depends on (FS)"), and is a no-op for every other link type. */
export function formatIssueLinkType(linkType: IssueLinkType, dependencyType?: IssueDependencyType): string {
  if (linkType === 'Depends on' && dependencyType) return `Depends on (${dependencyType})`;
  return linkType;
}
